/**
 * An interaction type that can be conducted with a company
 */
export enum InteractionType {
  PHONE = 'phone',
  EMAIL = 'email',
  MEETING = 'calendar',
  REMINDER = 'reminder',
}
